import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IncludesChecklist() {
  const items = [{
    title: 'Contenido 100% argentino',
    desc: 'Josemaría, Cauchari-Olaroz, Cerro Negro, Veladero, Navidad, RIGI 2024, SEGEMAR'
  }, {
    title: 'Material imprimible',
    desc: 'Listo para usar en el aula o entregar al alumno'
  }, {
    title: 'Fichas de referencia rápida',
    desc: 'Para consultar mientras enseñás'
  }, {
    title: 'Ejercicios resueltos paso a paso',
    desc: 'Con datos reales de minas y proyectos argentinos'
  }, {
    title: 'Vocabulario técnico explicado',
    desc: 'Sin tecnicismos innecesarios para el nivel del aula'
  }, {
    title: 'Conexión con la actualidad',
    desc: 'RIGI 2024, litio 2026, Josemaría en construcción, Minería 4.0'
  }, {
    title: 'Contexto histórico argentino',
    desc: 'Desde los pueblos originarios hasta los mega-proyectos de cobre y litio'
  }, {
    title: '5 Bonos estratégicos',
    desc: 'Actividades, evaluaciones, planificaciones, recursos visuales y proyectos'
  }, {
    title: 'Garantía de 7 días',
    desc: 'Sin preguntas ni formularios'
  }, {
    title: 'Acceso inmediato',
    desc: 'Descarga directa tras la compra'
  }, {
    title: 'Actualizaciones gratuitas',
    desc: 'Acceso de por vida al material'
  }];
  return <section className="py-12 bg-white border-y border-sand" data-id="element-175">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-176">
        <h3 className="text-2xl font-bold text-center mb-10 text-forest-dark" data-id="element-177">
          ✅ TODOS LOS TOMOS INCLUYEN
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-178">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 p-3 rounded-lg hover:bg-sand/30 transition-colors" data-id="element-179">
              <CheckCircle2 className="w-5 h-5 text-forest shrink-0 mt-0.5" data-id="element-180" />
              <div data-id="element-181">
                <span className="text-forest-dark font-bold block" data-id="element-182">
                  {item.title}
                </span>
                <span className="text-muted text-sm" data-id="element-183">{item.desc}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}